import isNil from 'lodash.isnil';
import { getUniqueMeasuresForGrades } from '../../../utils/shared/gradeToMeasureUtils';
import {
    FR_EXPRESS_VIEW_MEASURES,
    MEASURE,
    MEASURES,
} from '../../../constants/reading/MeasuresConstants';
import isStandaloneExpress from '../../../utils/reading/expressUtils';
import { getFrReadingMeasureGradeMapper } from '../../../constants/reading/DefaultGradeToMeasureMapper';

const { TRO, OVERALL } = MEASURE;

const getAvailableMeasuresForView = (gradeKeys, measures, gradeToMeasureMapper) => {
    const frGradeSpecificMeasureMapper = getFrReadingMeasureGradeMapper(gradeToMeasureMapper);

    return getUniqueMeasuresForGrades(frGradeSpecificMeasureMapper, MEASURES, gradeKeys).filter(
        measure => measures.includes(measure.key),
    );
};

export const isStudentAssessed = statuses =>
    !isNil(
        statuses.find(status => {
            if (status.measure === TRO) {
                return status.isComplete;
            }

            return !isNil(status) && !isNil(status.interp);
        }),
    );

export const isStudentInProgress = statuses =>
    !isNil(
        statuses.find(status => {
            if (status.measure === TRO) {
                return !status.isComplete;
            }

            return !isNil(status) && isNil(status.interp);
        }),
    );

export const isShowOnSummaryViewByMeasure = (licenseInfo, measure) =>
    measure === OVERALL ||
    (isStandaloneExpress(licenseInfo) && FR_EXPRESS_VIEW_MEASURES.includes(measure));

export default getAvailableMeasuresForView;
